module.exports = __webpack_public_path__ + "img/35.25834cfc.jpg";